/**
 * ConfigApplication
 * configure application level providers
 *
 * @class ConfigApplication
 * @memberof mwApp
 * @see mwApp
 * @emits mwApp.event:loginRequired
 *
 * @ngdoc config
 * @name mwApp.config:ConfigApplication
 */
/* @ngInject */
export default function ConfigApplication ($qProvider, $compileProvider, $httpProvider) {
  //

  // add global response handler
  $httpProvider.interceptors.push(/* @ngInject */ function ($q, $rootScope, $log, $window, e401Svc, alertLiteSvc, keycloakAdapterSvc, $state, storageSvc) {
    return {
      request: function (config) {
        if (window.ENV.APP_KEYCLOAK_ENABLED && keycloakAdapterSvc.inited) {
          keycloakAdapterSvc.setAuthHeader(config)
        }
        return config
      },
      /*
       * global response interceptor
       */
      response: function (response) {
        $rootScope.isAuthenticated = true
        if (response.config && response.config.url.indexOf('api/') === 0) {
          $rootScope.maintenance = 0
        }

        $rootScope.PROVIDER = window.ENV.APP_PROVIDER

        switch (response.status) {
          case 200: // update resource
          case 201: // create resource
            // update time of last successful request to api
            e401Svc.updateLastAccess(response)

            // if 'Location' header exists -> add object {id:<id>} (or field 'id') to body
            var loc = response.headers('Location')
            if (loc) {
              response.data = response.data || {}
              response.data.id = response.data.id || +loc.split('/').pop()
            }
            break
        }
        return response
      },

      /*
       * global error handler
       */
      responseError: function (rejection) {
        if (rejection.config && rejection.config.url.indexOf('api/') === 0) {
          $rootScope.maintenance = 0
        }

        // if there is request to auth or logout - pass error through
        if (rejection.config && (rejection.config.url === 'auth' ||
          rejection.config.url === 'logout')) {
          return $q.reject(rejection)
        }

        const aclsIntersectionPhrase = 'has conflicts with other Organization based ACLs'
        const subscriptionDiscountsPhrase = 'You already have an active Rule'

        switch (rejection.status) {
          case -1: // some weird error
            $log.log('Weird error...', rejection)
            break

          case 403: // Forbidden
            if (!e401Svc.isAuthenticated()) {
              $rootScope.isAuthenticated = e401Svc.isAuthenticated()
              const userType = storageSvc.local.get('userType')

              if (userType === 'SYSTEM') {
                $state.go('app.403su')
              } else {
                $state.go('app.403')
              }
            }
            // alertLiteSvc.alertError(rejection)
            break

          case 401: // Unauthorized
            // check time of last successful request
            // if last request was more than 1 hour ago, set authenticated to false and redirect to login page
            if (!e401Svc.checkLastAccess()) {
              e401Svc.rejectAll() // reject all postponed requests
              $window.setTimeout(() => $window.location.reload(), 1) // TODO think about avoid page reloading
              rejection.data = null // to avoid error alert on login screen
              return $q.reject(rejection)
            }

            var deferred = $q.defer()
            e401Svc.add(deferred, rejection) // add request to postponed queue

            /**
             * Event occurs when backend return 401 or 403 response <br>
             * Fires in {@link mwApp.config:ConfigApplication} module configuration
             *
             * @event event:loginRequired
             * @memberof mwApp
             */
            $rootScope.$emit('event:loginRequired')
            return deferred.promise

          case 400:
            if (rejection.data.includes(aclsIntersectionPhrase)) {
              rejection.newData = rejection.data.split('\n').slice(1, -1)
              rejection.data = {}
            }
            if (rejection.data.includes(subscriptionDiscountsPhrase)) {
              rejection.data = 'You already have an identical rule.\nPlease change one of the rules'
            }
            break

          case 402:
            $window.location.href = '/nora/suspended.html'
            break

          case 451:
            if (window.ENV.APP_KEYCLOAK_ENABLED) {
              keycloakAdapterSvc.logout()
            }
            break

          case 405: // Method Not Allowed
          case 501: // Not Implemented
            rejection.data = 'API Error : ' + rejection.statusText
            break

          case 500: // Internal Server Error
            $log.log(rejection.data)
            break

          case 502: // Bad Gateway
          case 503: // Service Unavailable
          case 504: // Gateway Time-out
            rejection.data = null // remove error message, to avoid alertSvc show it
            $rootScope.maintenance = rejection.status
            break
        }
        return $q.reject(rejection)
      }
    }
  })

  // use $applyAsync for all http requests
  $httpProvider.useApplyAsync(true)

  if (process.env.NODE_ENV === 'development') {
    $compileProvider.debugInfoEnabled(true)
  } else {
    $compileProvider.debugInfoEnabled(false)
    $qProvider.errorOnUnhandledRejections(false) // disable messages about unhandled promise rejections
  }
}
